module.exports = __webpack_public_path__ + "img/26.6744348f.png";